import styled from "styled-components";

export const Container = styled.div`
width: 100%;
display: flex;
flex-direction: column;
gap: 2rem;

h1{
    font-weight: 600;
}
.weight{
    color: var(--reset-button);
    font-weight: 800;
    font-size: 1.6rem;
}
`